export default __webpack_public_path__ + "static/media/wegovy-clean-the-injection-site.3bb57bba.mp4";